import React from 'react';
import { Query } from '@apollo/client/react/components';
import env from 'bench-environment';

import { GET_CURRENT_USER } from 'client-web-app/queries';
import SidebarButton from './SidebarButton';

const goToBusinesses = () => {
  window.location.href = `${env.location.cwa}/businesses`;
};

/**
 * Fetches the current user context to determine if they have access to multiple
 * clients and renders the dashboard button if they do.
 *
 * Note: Query fetches data cached by previous request made in src/data/user.js
 */
const DashboardButtonContainer = () => (
  <Query query={GET_CURRENT_USER}>
    {({ data, loading, error }) => {
      if (loading || error || !data) {
        return null;
      }
      const hasAccessToMultipleClients = data.currentUser.accessibleClientIds.length > 1;
      return (
        hasAccessToMultipleClients && (
          <SidebarButton
            testId="dashboard-sidebar-link"
            icon="chevronLeft"
            onClick={goToBusinesses}
            text="Dashboard"
          />
        )
      );
    }}
  </Query>
);

export default DashboardButtonContainer;
